import { render, staticRenderFns } from "./DescribeShippment.vue?vue&type=template&id=4d5debdc&scoped=true"
import script from "./DescribeShippment.vue?vue&type=script&lang=js"
export * from "./DescribeShippment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5debdc",
  null
  
)

export default component.exports